var _a, _b;
import { LICENSE_TIERS } from './license.js';
import { expectType, zDocument } from './model.js';
import { z } from 'zod';
export const timeZones = [
    'America/Chicago',
    'America/New_York',
    'America/Denver',
    'America/Los_Angeles',
    'America/Phoenix'
];
export const aiServices = ['None', 'OpenAI'];
export const DefaultFeedPromotionDensity = 10;
export const BlockThresholds = ['Low', 'Medium', 'High', 'Off'];
export const DefaultAutoBlockThreshold = 'Medium';
export const AutoBlockThresholds = {
    Low: -9,
    Medium: -15,
    High: -27,
    Off: -Infinity
};
export const SendMailServices = [
    'Gmail',
    '1und1',
    'AOL',
    'DebugMail.io',
    'DynectEmail',
    'FastMail',
    'GandiMail',
    'Gmail',
    'Godaddy',
    'GodaddyAsia',
    'GodaddyEurope',
    'hot.ee',
    'Hotmail',
    'iCloud',
    'mail.ee',
    'Mail.ru',
    'Mailgun',
    'Mailjet',
    'Mandrill',
    'Naver',
    'Postmark',
    'QQ',
    'QQex',
    'SendCloud',
    'SendGrid',
    'SES',
    'Sparkpost',
    'Yahoo',
    'Yandex',
    'Zoho',
    'log-type'
];
export const SupportedSendMailServices = ['Gmail', 'log-type'];
export const zSiteMailSettings = z.object({
    sendMailServiceType: z.enum(SendMailServices).or(z.literal('')),
    sendMailUser: z.string(),
    sendMailPassword: z.string(),
    sendMailUseOAuth2: z.boolean(),
    sendMailOauth2ClientId: z.string(),
    sendMailOauth2Secret: z.string(),
    sendMailOauth2RefreshToken: z.string(),
    sendMailOauth2AccessToken: z.string(),
    sendMailAPIKey: z.string()
});
export const zSiteSettings = zDocument
    .extend({
    type: z.literal('siteSettings'),
    siteName: z.string(),
    legalName: z.string(),
    description: z.string(),
    language: z.string(),
    currency: z.string(),
    lightIcon: z.string(),
    darkIcon: z.string(),
    lightBanner: z.string(),
    darkBanner: z.string(),
    welcomeEmail: z.string(),
    timezone: z.enum(timeZones),
    termsOfService: z.string(),
    gettingStarted: z.string(),
    termsOfServiceVersion: z.number(),
    adminEmail: z.string(),
    serverUrl: z.string(),
    serverPort: z.number(),
    feedRandomnessFactor: z.number().gte(0).lte(10),
    promotionCostPerDay: z.number().gte(0),
    allowAnonymous: z.boolean(),
    aiServiceKey: z.string(),
    aiService: z.enum(aiServices),
    moderatePosts: z.boolean(),
    moderateComments: z.boolean(),
    level1Prompt: z.string(),
    level2Prompt: z.string(),
    level3Prompt: z.string(),
    stripeAPIKey: z.string(),
    stripeTokenProductKey: z.string(),
    feedPromotionDensity: z.number(),
    subscriptionCost: z.number(),
    subscriptionDuration: z.number(),
    stripeSubscriptionProductKey: z.string(),
    autoBlockThreshold: z.enum(BlockThresholds)
})
    .merge(zSiteMailSettings);
expectType({});
expectType({});
export const zPublicSiteInformation = zSiteSettings
    .pick({
    description: true,
    legalName: true,
    darkBanner: true,
    darkIcon: true,
    siteName: true,
    lightIcon: true,
    lightBanner: true,
    allowAnonymous: true,
    language: true,
    currency: true,
    timezone: true,
    promotionCostPerDay: true,
    termsOfService: true,
    termsOfServiceVersion: true,
    gettingStarted: true,
    feedPromotionDensity: true,
    subscriptionCost: true,
    subscriptionDuration: true
})
    .extend({ supportsPayments: z.boolean(), license: z.enum(LICENSE_TIERS) });
expectType({});
expectType({});
export const DefaultSiteSettings = {
    _id: 'siteSettings',
    _rev: '',
    created: '',
    updated: '',
    type: 'siteSettings',
    siteName: 'QuirkLocal',
    legalName: 'QuirkLocal, LLC',
    description: `QuirkLocal is a pilot community building website for Oak Park, IL. It's a place to find local news, businesses and engage with the community at large.`,
    language: 'en-US',
    currency: 'USD',
    lightIcon: '',
    darkIcon: '',
    lightBanner: '',
    darkBanner: '',
    welcomeEmail: `## Welcome to {siteName}, {userName}\n\nWe're glad you're here.\n\n
	Please click the link below to activate your account.
	\n\n[Activate Your Account]({activationUrl})
	\n\nIf this link doesn't work or it has expired, please try this [Resend Email]({resendURL})
	\n\nWhen you first login you will be asked to review and agree to the terms of service, that's all a bit technical and we know you'll read it all, but here are some general guidelines:
	\n\n
	- We ask that you use the same name you use in-person in the community, on this website as your user name\n
	- This website is designed to build community, don't tear it or other people down with your words or actions. Respect others and be on your best behavior.\n
	- We respect your data privacy absolutely and don't share or sell your data. You can delete your data any time you want.\n
	- Posts and comments are accessible only by registered users.\n
	- Don't spam, spammers will be removed. No, we don't need our ducts cleaned.
	\n\nEnjoy!\n`,
    timezone: 'America/Chicago',
    termsOfService: `# Terms of Service

Welcome to {siteName} your local news and social media website! We're glad you're here.

This website is owned an operated by {legalName}.

By using our website, you agree to abide by the following terms of service:

1. You must be 13 years or older to use our website. If you are under 13, please do not create an account or use our website.

2. You must be a member of the local community served by this website. This includes physically residing, at least part time, in the geography served by this website, or living nearby and having significant interactions
with the community's businesses, customers, or institutions. Example: A vacationer does not reside in the locality and so is not a member of the community, however a business owner of a business in an adjoining town that 
serves this community would be considered a member of the community. 

We reserve the right to make judgements as to community membership and terminate your account if you don't qualify.

3. You are responsible for your own content. We do not claim ownership of any content that you post on our website. 
However, by posting content, you grant us a non-exclusive, royalty-free, perpetual, and worldwide license to use, reproduce, distribute, and display your content.

4. You must not post any illegal or offensive content. This includes, but is not limited to, content that is racist, sexist, or promotes
 physical violence against another person or group. We reserve the right to remove any content that we deem to be in violation of this rule.

5. We reserve the right to remove any content that is deemed offensive by generally accepted community standards.

6. You may not use our website to promote your business or sell products without our express permission. 
Limited permission will be granted to sponsors, subject to the restrictions of the sponsorship agreement, 
and to businesses that purchase the right to advertise via promoted posts or other promoted content.

7. You must comply with all local, state, national, and international laws when using our website.

8. If you violate any of these terms of service, we reserve the right to terminate your account and block you from using our website.

9. _Data Privacy_ The website stores your posts, comments, likes, dislikes and other histories of your interactions with website content
 and other users. This information is used to generate the website and to suggest content to users. We will not sell this information to 
 third parties. We will not share your information with third parties. This committment to data privacy is irrevocable and will not be amended.

10. Your posts and comments will only be accessible on this website to registered user of the website.

11. Administrative staff reserve the right to view all personal information collected by the website in order to research technical issues, 
or research reports of abuse or violations of the terms of service. We also reserve the right to share information to comply with a 
legally binding request from law enforcement or other legally authorized entities.

12. _Right to be Forgotten_ You may, at any time, request that your information be deleted. This includes all of your posts, all of your comments, and your personal account details. After you have requested deletion,
 this content will be removed from display on the website permanently. Some information may be preserved in backups, extracts, or reports of abuse or violations of the terms of service. 
 For example, we will not physically delete reported posts as they may be subject to future legal action or research.

Please note that these terms of service are subject to change at any time. We will do our best to notify you of any changes, 
but it is your responsibility to stay informed about the terms of service for our website.

If you have any questions or concerns about these terms of service, please contact us. We're here to help!`,
    termsOfServiceVersion: 1,
    gettingStarted: `# Getting Started

Welcome to {siteName} your local news and social media website! We're glad you're here.

Here at {siteName} we value online safety and civility and want to make sure that you have a great experience. Here are some tips to get you started:
1. Respect the community. This is a place to build community, not tear it down. Be on your best behavior.
2. When you like or dislike something, you are telling us you want to see more or less of things like that. Rate posts and comments with this in mind. If you dislike somebody's posts enough times, you will stop seeing them.
3. If you see something that you think is inappropriate, please report it. We will review it and take appropriate action.
4. Post authors have the right to delete comments on their posts for any reason. Their posts are their 'space' and they can do with it what they want. If you don't like that, post something yourself.
5. If you have a question, ask it. If you have a complaint, let us know. We're here to help. Find the feedback section in the Settings Menu.
`,
    adminEmail: '',
    serverUrl: typeof process !== 'undefined' ? ((_a = process.env) === null || _a === void 0 ? void 0 : _a.SERVER_NAME) || 'http://localhost' : 'http://localhost',
    serverPort: Number(typeof process !== 'undefined' ? ((_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b.SERVER_PORT) || 3000 : 3000),
    feedRandomnessFactor: 5,
    promotionCostPerDay: 1,
    allowAnonymous: false,
    aiServiceKey: '',
    aiService: 'None',
    moderatePosts: false,
    moderateComments: false,
    level1Prompt: 'Generally acceptable to most readers. Should not contain profanity and should have a neutral or positive tone.',
    level2Prompt: 'Some might find objectionable with more aggressive language or a more negative tone, but using mostly civil language.',
    level3Prompt: 'Contains profanity directed at others, is overtly aggressive, confrontational, threatening, or may be suspected spam.',
    stripeAPIKey: '',
    stripeTokenProductKey: '',
    feedPromotionDensity: DefaultFeedPromotionDensity,
    subscriptionCost: 0,
    subscriptionDuration: 12,
    stripeSubscriptionProductKey: '',
    sendMailServiceType: '',
    sendMailPassword: '',
    sendMailUser: '',
    sendMailUseOAuth2: false,
    sendMailOauth2Secret: '',
    sendMailOauth2ClientId: '',
    sendMailOauth2RefreshToken: '',
    sendMailOauth2AccessToken: '',
    sendMailAPIKey: '',
    autoBlockThreshold: 'Medium'
};
